import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import './../../shared/rxjs-operators';
import { LogService, ApiService, CacheService, AppContext, Vessel } from './../../shared';

@Injectable()
export class VesselsSearchService {
  vessels: Observable<any>;

  autoOn = false;
  loaderOn = false;
  noResult = false;

  constructor(private logger: LogService, private api: ApiService, private cache: CacheService, public app: AppContext) {
  }

  startSearch() {
    this.autoOn = true;
    this.loaderOn = true;
    this.noResult = false;
  }

  getVessels(term: string): Observable<any> {
    this.logger.log('vessel-search.service', 'getVessels', term);
    this.startSearch();
    // let cache = this.cache.get('vessels' + term);
    let promise = this.api.getApiClient().then(client => this.callGetVessels(client, term));
    let server = Observable.fromPromise(promise);
    this.vessels = server;
    // this.vessels = Observable.concat(cache, server);
    // this.cache.updateCache('vessels' + term, this.vessels);

    return this.vessels;
  }

  callGetVessels(apigClient: any, term: string): Promise<any> {
    this.logger.log('vessels-search.service', 'callGetVessels', term);
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: {
          'Content-Type': 'application/json'
        },
        queryParams: {
          search: term
        }
      };
      try {
        apigClient.vesselsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('vessels-search.service', 'resolve', result);
            let formatted = this.endSearch(result.data);
            resolve(formatted);
          }).catch((err) => {
            this.endSearch(null);
            this.autoOn = false;
            this.api.handleError(err);
          });
      } catch (ex) {
        this.logger.log('vessels-search.service', 'catch', ex);
        return reject(ex);
      }
    });
  }

  endSearch(data: any): any {
    this.loaderOn = false;

    try {
      let formatted = new Array<Vessel>();

      for (let current = 0; current < data.items.length; current++) {
        formatted.push(new Vessel(data.items[current]));
      }

      return formatted;
    } catch (ex) {
      this.noResult = true;
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/vessels-search/vessels-search.service.ts